import React, { useEffect, useState } from 'react';
import {
  FlexboxGrid,
  Col,
  Form,
  Stack,
  Input,
  SelectPicker,
  InputNumber,
  Uploader,
  Message,
  toaster,
  IconButton,
  Loader,
  Button,
  Modal,
  InputGroup
} from 'rsuite';
import PlusIcon from '@rsuite/icons/Plus';
import TrashIcon from '@rsuite/icons/Trash';
import ImageIcon from '@rsuite/icons/Image';
import globalIP from '@/GlobelIP';
import { isValidURL, validateEmail2 } from '@/functions';

const type = ['International', 'Domestic'].map(item => ({ label: item, value: item }));
function previewFile(file, callback) {
  const reader = new FileReader();
  reader.onloadend = () => {
    callback(reader.result);
  };
  reader.readAsDataURL(file);
}

const CompanyReg = ({ open, handleClose }) => {
  const [data1, setData1] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    const response = await fetch(`${globalIP}/api/company-details?populate=*`);
    const json = await response.json();
    setData1(json.data);
  };

  const [uploading, setUploading] = useState([]);
  const [fileInfo, setFileInfo] = useState(null);
  const [data, setData] = useState([
    {
      cmpnm: '',
      address: '',
      country: '',
      state: '',
      city: '',
      pin_no: '0',
      reg_type: '',
      org_type: '',
      faxno: '0',
      email_id: '',
      contactno: '',
      website: '',
      gstno: '',
      cmpcd: 'CMP1',
      madeby: 'Shantanu',
      GLink: '',
      Type: '',
      Authorised: true,
      OwnerName: '',
      UserLimit: 0,
      SkuLimit: 0,
      LicNo: '',
      Bank_Detail: [
        {
          bankName: '',
          branchName: '',
          ifsc_code: '',
          accountno: '',
          bankaddress: '',
          swiftcode: ''
        }
      ],
      ContactDetail: [
        {
          Name: '',
          mobileno: '',
          email: ''
        }
      ],
      Logo: null
    }
  ]);
  const [fileInfoList, setFileInfoList] = useState([null]);

  const handleInputChange = (index, field, value) => {
    const newDataList = [...data];
    newDataList[index][field] = value;
    setData(newDataList);
  };

  const handleImageUpload = (index, fileList) => {
    if (!fileList || fileList.length === 0) return;

    const file = fileList[0].blobFile;
    const fileName = fileList[0].name;
    const extension = fileName.split('.').pop().toLowerCase();

    if (extension !== 'jpeg' && extension !== 'jpg') {
      toaster.push(<Message type="error">Only JPEG and JPG formats are allowed</Message>);
      return;
    }

    setUploading(prev => {
      const newUploading = [...prev];
      newUploading[index] = true;
      return newUploading;
    });

    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        if (width >= 150 && width <= 200 && height >= 150 && height <= 200) {
          setData(prevData => {
            const newData = [...prevData];
            newData[index] = { ...newData[index], Logo: file };
            return newData;
          });
        } else {
          toaster.push(
            <Message type="error">Image dimensions must be between 150x150px and 200x200px</Message>
          );
        }
        setUploading(prev => {
          const newUploading = [...prev];
          newUploading[index] = false;
          return newUploading;
        });
      };
      img.src = reader.result;
    };

    reader.readAsDataURL(file);
  };

  const addCompany = () => {
    setData([
      ...data,
      {
        cmpnm: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pin_no: '0',
        contactno: '',
        reg_type: '',
        org_type: '',
        faxno: '0',
        email_id: '',
        website: '',
        gstno: '',
        cmpcd: 'CMP1',
        madeby: 'Shantanu',
        GLink: '',
        Type: '',
        Authorised: true,
        OwnerName: '',
        UserLimit: 0,
        SkuLimit: 0,
        LicNo: '',
        Bank_Detail: [
          {
            bankName: '',
            branchName: '',
            ifsc_code: '',
            accountno: '',
            bankaddress: '',
            swiftcode: ''
          }
        ],
        ContactDetail: [
          {
            Name: '',
            mobileno: '',
            email: ''
          }
        ],
        Logo: null
      }
    ]);
    setFileInfoList([...fileInfoList, null]);
  };
  const message1 = (
    <Message showIcon type="success" closable>
      Company Details Saved Successfully.
    </Message>
  );
  const message2 = (
    <Message showIcon type="error">
      Please fill the company details.
    </Message>
  );
  const [generatedLicNo, setGeneratedLicNo] = useState('');
  const [emailid, setEmailId] = useState('');
  const [company, setComapny] = useState('');
  const generateLicNo = () => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Month is 0-based
    const year = today.getFullYear();

    return `UG${day}${month}${year}`;
  };
  useEffect(() => {
    if (generatedLicNo && emailid && company) {
      sendemail();
    }
  }, [generatedLicNo, emailid, company]);
  const sendemail = async () => {
    const endpoint = `${globalIP}/api/email`;
    const data = {
      to: emailid,
      subject: `Your Company License Number - ${generatedLicNo}`,
      html: `
Dear ${company},

We are pleased to inform you that your company has been successfully registered in our system.

Your License Number is: ${generatedLicNo}

Please keep this license number for your records. It will be required for any future correspondence or service requests.

If you have any questions or need assistance, feel free to reach out to our support team.

Thank you for choosing our services.

Best regards,  
Your Company Name
`
    };
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        handleClose();
        toaster.push(
          <Message showIcon type="success">
            Email sent successfully!
          </Message>,
          { placement: 'topEnd' }
        );
      } else {
        console.error('Failed to send email');
        toaster.push(
          <Message showIcon type="error">
            Failed to send email
          </Message>,
          { placement: 'topEnd' }
        );
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  const url = `${globalIP}/api/company-details`;
  const submit = e => {
    e.preventDefault();
    const licNoToday = generateLicNo(); // Generate once
    setGeneratedLicNo(licNoToday);
    let startingIndex = data1.length;
    // Validate all companies before submission
    for (let i = 0; i < data.length; i++) {
      const company = data[i];
      if (!company.cmpnm.trim()) {
        toaster.push(
          <Message showIcon type="error">
            Company Name is required
          </Message>
        );
        return;
      }
      if (company.contactno.trim() && company.contactno.trim().length > 12) {
        toaster.push(
          <Message showIcon type="error">
            Please check Contact Number.
          </Message>
        );
        return;
      }
      const nextCode = startingIndex + i + 1;
      company.cmpcd = `CMP-${nextCode.toString().padStart(3, '0')}`;
      company.LicNo = licNoToday;
      setEmailId(data[0].email_id);
      setComapny(data[0].cmpnm);
      const formData = new FormData();
      formData.append('data', JSON.stringify(company)); // Append all company data as JSON
      // Append all logos
      if (company.Logo && company.Logo instanceof File) {
        formData.append('files.Logo', company.Logo);
      }

      // Send data to backend
      fetch(url, {
        method: 'POST',
        body: formData
      })
        .then(response => response.json())
        .then(responseData => {
          // console.log('Response from server:', responseData);
          // Reset state after successful submission
          setData([
            {
              cmpnm: '',
              address: '',
              country: '',
              state: '',
              city: '',
              pin_no: '',
              contactno: '',
              reg_type: '',
              org_type: '',
              faxno: '',
              email_id: '',
              website: '',
              gstno: '',
              cmpcd: 'CMP1',
              madeby: 'Shantanu',
              GLink: '',
              Type: '',
              Authorised: true,
              OwnerName: '',
              UserLimit: 0,
              SkuLimit: 0,
              LicNo: '',
              Bank_Detail: [
                {
                  bankName: '',
                  branchName: '',
                  ifsc_code: '',
                  accountno: '',
                  bankaddress: '',
                  swiftcode: ''
                }
              ],
              ContactDetail: [
                {
                  Name: '',
                  mobileno: '',
                  email: ''
                }
              ],
              Logo: null
            }
          ]);
          setFileInfoList([null]);
          CompanyReg();
          toaster.push(<Message type="success">Companies saved successfully!</Message>);
        })
        .catch(error => console.error('Error submitting data:', error));
    }
  };

  return (
    <Modal open={open} onClose={handleClose} size="full" backdrop="static">
      <Modal.Header>
        <Modal.Title>
          <Stack spacing={10}>
            <b>Register</b>
            {/* <IconButton icon={<PlusIcon />} size="xs" active onClick={addCompany} /> */}
          </Stack>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data.map((data, index) => (
          <FlexboxGrid key={index} justify="start">
            <FlexboxGrid.Item as={Col} colspan={24} md={16}>
              <FlexboxGrid key={index} justify="start">
                {/* Company Name */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>
                    <Stack>
                      <p>Company Name</p>
                      <p style={{ color: 'red' }}>*</p>
                    </Stack>
                  </Form.ControlLabel>
                  <Input
                    id={`cmpnm-${index}`}
                    name="cmpnm"
                    value={data.cmpnm}
                    onChange={value => handleInputChange(index, 'cmpnm', value)}
                  />
                </FlexboxGrid.Item>

                {/* Industry */}
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.ControlLabel>Industry</Form.ControlLabel>
                  <SelectPicker data={[]} block />
                </FlexboxGrid.Item>

                {/* Type */}
                <FlexboxGrid.Item as={Col} colspan={24} md={4}>
                  <Form.ControlLabel>Type</Form.ControlLabel>
                  <SelectPicker
                    id={`Type-${index}`}
                    name="Type"
                    value={data.Type}
                    onChange={value => handleInputChange(index, 'Type', value)}
                    data={type}
                    block
                  />
                </FlexboxGrid.Item>

                {/* Address */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Address</Form.ControlLabel>
                  <Input
                    id={`address-${index}`}
                    name="address"
                    value={data.address}
                    onChange={value => handleInputChange(index, 'address', value)}
                  />
                </FlexboxGrid.Item>

                {/* City */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8} style={{ marginBottom: '10px' }}>
                  <Form.ControlLabel>City</Form.ControlLabel>
                  <Input
                    id={`city-${index}`}
                    name="city"
                    value={data.city}
                    onChange={value => handleInputChange(index, 'city', value)}
                  />
                </FlexboxGrid.Item>

                {/* Owner Name */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Owner Name</Form.ControlLabel>
                  <Input
                    id={`OwnerName-${index}`}
                    name="OwnerName"
                    value={data.OwnerName}
                    onChange={value => handleInputChange(index, 'OwnerName', value)}
                  />
                </FlexboxGrid.Item>

                {/* Owner Mobile */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Owner Mobile</Form.ControlLabel>
                  <Input
                    id={`contactno-${index}`}
                    name="contactno"
                    value={data.contactno}
                    onChange={value => handleInputChange(index, 'contactno', value)}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>Email</Form.ControlLabel>
                  <Input
                    id={`email_id-${index}`}
                    name="email_id"
                    value={data.email_id}
                    onChange={value => handleInputChange(index, 'email_id', value)}
                  />
                </FlexboxGrid.Item>
                {/* IP Address */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>IP Address.</Form.ControlLabel>
                  <Input
                    id={`GLink-${index}`}
                    name="GLink"
                    value={data.GLink}
                    onChange={value => handleInputChange(index, 'GLink', value)}
                  />
                </FlexboxGrid.Item>

                {/* User Limit */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>User Limit</Form.ControlLabel>
                  <InputNumber
                    id={`UserLimit-${index}`}
                    name="UserLimit"
                    value={data.UserLimit}
                    onChange={value => handleInputChange(index, 'UserLimit', value)}
                  />
                </FlexboxGrid.Item>

                {/* SKU Limit */}
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Form.ControlLabel>SKU Limit</Form.ControlLabel>
                  <InputNumber
                    id={`SkuLimit-${index}`}
                    name="SkuLimit"
                    value={data.SkuLimit}
                    onChange={value => handleInputChange(index, 'SkuLimit', value)}
                  />
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item as={Col} colspan={24} md={8}>
              <span style={{ fontSize: '10px', color: 'red' }}>
                Image dimensions should be between 150x150px and 200x200px *
              </span>
              <Stack justifyContent="center">
                <Uploader
                  onChange={fileList => handleImageUpload(index, fileList)}
                  fileListVisible={false}
                  listType="picture"
                  accept=".jpeg, .jpg"
                  action={''}
                >
                  <button style={{ width: 232, height: 196 }}>
                    {uploading[index] && <Loader backdrop center />}
                    {data.Logo ? (
                      <img
                        src={uploading[index].Logo}
                        alt="Company Logo"
                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                      />
                    ) : (
                      <ImageIcon style={{ fontSize: 80 }} />
                    )}
                  </button>
                </Uploader>
              </Stack>
              <Stack justifyContent="center">
                <IconButton
                  size="md"
                  icon={<TrashIcon />}
                  onClick={() => setFileInfoList([...fileInfoList, null])}
                  active
                />
              </Stack>
            </FlexboxGrid.Item>
          </FlexboxGrid>
        ))}

        {/* Logo Upload */}
        {/* <FlexboxGrid.Item as={Col} colspan={24} md={6}>
            <span style={{ fontSize: '10px', color: 'red' }}>
              Image dimensions should be between 150x150px and 200x200px *
            </span>
            <Stack justifyContent="center">
              <Uploader
                onChange={file => handleImageUpload(data.length - 1, file)}
                fileListVisible={false}
                listType="picture"
                accept=".jpeg, .jpg"
                action={''}
              >
                <button style={{ width: 232, height: 196 }}>
                  {uploading && <Loader backdrop center />}
                  {fileInfoList[data.length - 1] ? (
                    <img src={fileInfoList[data.length - 1]} />
                  ) : (
                    <ImageIcon style={{ fontSize: 80 }} />
                  )}
                </button>
              </Uploader>
            </Stack>
            <Stack justifyContent="center">
              <IconButton
                size="md"
                icon={<TrashIcon />}
                onClick={() => setFileInfoList([...fileInfoList, null])}
                active
              />
            </Stack>
          </FlexboxGrid.Item> */}
      </Modal.Body>
      {/* Save Button */}
      <Modal.Footer>
        {data1.length > 0 ? (
          <b>Registered</b>
        ) : (
          <Button
            appearance="primary"
            color="cyan"
            onClick={submit}
            className="company-btn"
            disabled={data1.length > 0}
          >
            Save
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default CompanyReg;
